<template>
    <div class="dropdown">
        <a 
            :id="`dropdown-${_uid}`" 
            role="button" 
            data-toggle="dropdown" 
            aria-haspopup="true" 
            aria-expanded="false"
            class="dropdown-trigger hover:no-underline inline-block flex"
            :class="triggerClass"
            @click.stop="toggle($event)"
            @mouseover.stop="toggle($event)"
        >
            <slot name="trigger"></slot>
        </a>

        <div 
            class="dropdown-menu"
            :class="menuClass"
            :aria-labelledby="`dropdown-${_uid}`"
            ref="menu"
        >
            <slot name="items"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            triggerClass: {
                type: String,
                default: ''
            },
            triggerType: {
                type: String,
                default: 'click'
            },
            menuClass: {
                type: String,
                default: 'dropdown-menu-right'
            }
        },
        mounted() {
            document.addEventListener('click', (e) => {
                if (this.$refs.menu) {
                    this.$refs.menu.classList.remove('show');
                }
            })
        },
        methods: {
            toggle(e) {
                if (e.type != this.triggerType) {
                    return;
                }

                let dropdowns = document.getElementsByClassName('dropdown-menu');
                
                for (let i = 0; i < dropdowns.length; i++) {
                    dropdowns[i].classList.remove('show');
                }

                if (this.$refs.menu.classList.contains('show')) {
                    this.$refs.menu.classList.remove('show');
                } else {
                    this.$refs.menu.classList.add('show');
                }
            }
        }
    }
</script>